import cn from "classnames";
import { useAppSelector } from "../../../../effects/useAppSelector";
import { KMatrixViewType } from "../../../../types/state/AmrDealsState";
import { useAppDispatch } from "../../../../effects/useAppDispatch";
import { createAmrPipelineActions } from "../../../../actions";
import { PipelineType } from "../../../../types/amr-pipeline/enums/PipelineType";

const actions = createAmrPipelineActions(PipelineType.Deals)

export function KMatrixViewTypeDropDown() {
    const dispatch = useAppDispatch();
    const kMatrixViewType = useAppSelector(s => s.issuanceMonitor.amrPipeline.deals.kMatrixViewType);
    const kMatrixViewTypeAutoChange = useAppSelector(s => s.issuanceMonitor.amrPipeline.deals.kMatrixViewTypeAutoChange)

    return (
        <div className="k-matrix-view-by">
            <label>View by:</label>
            <select
                className={cn("form-control form-control-sm form-select", { 'highlight': kMatrixViewTypeAutoChange })}
                value={kMatrixViewType}
                onChange={e => dispatch(actions.kMatrixViewTypeChanged(e.target.value as KMatrixViewType, false))}
            >
                <option value={KMatrixViewType.Default}>Default</option>
                <option value={KMatrixViewType.CE}>C/E</option>
                <option value={KMatrixViewType.MVOC}>MVOC</option>
            </select>
        </div>
    );
}